import { validatePassword } from '@/lib/validate';
import * as yup from 'yup';

export interface PasswordChangeFormValues {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

/** Yup schema for account password change (current + new + confirm). */
export function createPasswordChangeSchema(t: (key: string) => string) {
  return yup.object({
    currentPassword: yup.string().required(() => t('account_password_required_current')),
    newPassword: yup
      .string()
      .required(() => t('signup_required_password'))
      .test('password', function (value) {
        const result = validatePassword(value ?? '');
        if (result === true) return true;
        return this.createError({ message: result });
      }),
    confirmPassword: yup
      .string()
      .required(() => t('account_password_required_confirm'))
      .oneOf([yup.ref('newPassword')], () => t('account_password_mismatch')),
  });
}
